export const environment = {
  production: true,
  // apiHost: 'https://anstek.com/anstek-backend/api/index.php/',
  // imgUrl: 'https://anstek.com/anstek-backend/',
  apiHost: 'http://20.231.216.128/erp-backend/api/index.php/',
  imgUrl: 'http://20.231.216.128/erp-backend/',
  sessionPrefix: 'anstek'
};
